import * as Backend from "../backend.js";
import * as util from "../other/util.js";

// Shows the message history for a particular conversation
export default class DebugView extends util.GameComponent {
    constructor(props) {
        super(props);

        this.state = {};

        Backend.DEBUG_getGame((res) => {
            this.setState({
                game: res.game,
                code: "",
                json_filter: "",
                button_enabled: true,
                error: res.error,
            });
        });
    }

    render() {
        let error = this.state.error;
        if (error) {
            return (
                <div>
                    <h3>Error</h3>
                    <div className="warning-text">
                        {JSON.stringify(error, null, 2)}
                    </div>
                </div>
            );
        }

        let game = this.state.game;
        if (!game) {
            return (<util.LoadingBar thing={game} thingName="game" />);
        }

        let code = this.state.code;
        let json_filter = this.state.json_filter;
        let display = "game";
        let filter_error;

        if (json_filter !== "") {
            try {
                display = json_filter;
                // eslint-disable-next-line no-eval
                game = eval(json_filter);
            } catch (e) {
                display = "game";
                filter_error = e.toString();
            } finally {
            }
        }

        const game_str = game ? JSON.stringify(game, null, 2) : "";
        if (typeof (game) !== "object") {
            game = { fake: game };
        }
        return (
            <div>
                <div className="warning-text">
                    {JSON.stringify(this.state.error, null, 2)}
                </div>
                <h3>Code</h3>
                <textarea rows="8"
                    cols="70"
                    value={code}
                    onChange={(event) => {
                        this.onChangeCode(event.target.value);
                    }}
                    onKeyPress={(event) => {
                        if (event.key === "Enter" && event.getModifierState("Shift")) {
                            this.onSubmitCode();
                        }
                        return false;
                    }} />
                <button disabled={!this.state.button_enabled} onClick={() => {
                    this.onSubmitCode();
                }}>Execute
                </button>
                <h3>Json Filter</h3>
                <textarea rows="3"
                    cols="70"
                    value={json_filter}
                    onChange={(event) => {
                        this.onChangeJsonFilter(event.target.value);
                    }} />
                <div className="warning-text">
                    {JSON.stringify(filter_error, null, 2)}
                </div>
                <pre>{display} = {game_str}</pre>
                {/*{game_str.length > 10000 ? (<pre>{display} = {game_str}</pre>): undefined}*/}
                {/*{game_str.length <= 10000 ? (<ReactJson src={game} theme="harmonic" enableClipboard={false} style={{background: "#111132"}}/>): undefined}*/}
            </div>
        );
    }

    // game.galaxy._solar_systems[6][9].planets[4]

    onChangeCode(code) {
        this.setState({ code: code });
    }

    onSubmitCode() {
        this.setState({ button_enabled: false });
        Backend.DEBUG_runCode(this.state.code, (res) => {
            this.setState({
                game: res.game,
                button_enabled: true,
                error: res.error,
            });
        });
    }

    onChangeJsonFilter(json_filter) {
        this.setState({ json_filter: json_filter });
    }
}